(ns router.events
  (:require
   [very.re-frame.core :as rf]))

(rf/reg-sub
 :router/uri-params
 (fn [db]
   (get-in db [:uri :params])))
